const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");
let { Router } = require('./lib/router.blop');

async function indexHandler(_params, state) {
  state.page = 'index';
  console.log('indexHandler called');
};

async function dogPageIndexHandler(params, state) {
  state.page = 'dog';
  console.log('doggyIndexHandler called with', params);
};

function dogPageHandler(params, state) {
  state.page = 'dog';
  console.log('doggyHanlder called with', params);
  state.dogPage.choice = ({ breed: params.breed, image: params.image });
};

async function memePageHandler(params, state) {
  state.page = 'meme';
  console.log('memePageHandler called with', params);
};

function todoPageHandler(params, state) {
  state.page = 'todo';
  console.log('todoIndexHandler called with', params);
};

function statePageHandler(params, state) {
  state.page = 'state';
  console.log('statePageHandler called with', params);
};

async function petStorePageIndexHandler(params, state) {
  state.page = 'petstore';
  console.log('petStorePageIndexHandler called with', params);
};

function createRouter(state, global) {let router;
  router = new Router(null, state, global);

  router.add(({ path: '/todo', name: 'todo', handler: todoPageHandler }));
  router.add(({ path: '/meme', name: 'meme', handler: memePageHandler }));
  router.add(({ path: '/dogs/:breed/:image', name: 'doggy', handler: dogPageHandler }));
  router.add(({ path: '/dogs', name: 'dog', handler: dogPageIndexHandler }));
  router.add(({ path: '/petstore', name: 'petstore', handler: petStorePageIndexHandler }));
  router.add(({ path: '/state', name: 'componentstate', handler: statePageHandler }));
  router.add(({ path: '/fetch', name: 'fetch', handler: () => {
    state.page = 'fetch';
    console.log('fetch called');
  } }));
  router.add(({ path: '/', name: 'root', handler: indexHandler }));

  router.init();
  return router
};
module.exports = { Router, indexHandler, dogPageIndexHandler, dogPageHandler, memePageHandler, todoPageHandler, statePageHandler, petStorePageIndexHandler, createRouter };
